import { render, staticRenderFns } from "./NavegantesEdit.vue?vue&type=template&id=dfb87914&scoped=true"
import script from "./NavegantesEdit.vue?vue&type=script&lang=js"
export * from "./NavegantesEdit.vue?vue&type=script&lang=js"
import style0 from "./NavegantesEdit.vue?vue&type=style&index=0&id=dfb87914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb87914",
  null
  
)

export default component.exports